import SubmitYourCv from "../../../../src/components/submit-your-cv";
import * as React from 'react';
export default {
  SubmitYourCv,
  React
};